import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const LOST_BROKERAGE_SCENARIOS = [
  "EUIN is invalid or missing.",
  "KYC is incomplete or expired.",
  "Incomplete or missing nominee details in folio.",
  "Segregated schemes transactions.",
  "Change of broker without completing the necessary transfer or authorization procedures. *",
  "An error or mistake from RTA / AMC.",
  "Any other scenarios.",
];

export default function LostBrokerage() {
  const [processMonth, setProcessMonth] = useState("02-2026");

  const handleApply = (e) => {
    e.preventDefault();
    console.log({ processMonth });
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Lost Brokerage</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/brokerage/income-detail">Brokerage</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Lost Brokerage
                </li>
              </ol>
            </nav>
          </div>

          {/* Instructional header */}
          <p className="text-center text-secondary mb-4" style={{ fontSize: "15px", color: "#334155" }}>
            Get a detailed report on transactions with lost brokerage for a given month.
          </p>

          {/* Process Month card */}
          <div style={cardStyle}>
            <form onSubmit={handleApply}>
              <div className="mb-3">
                <label className="form-label small fw-semibold text-secondary mb-1 d-block">Process Month</label>
                <input
                  type="text"
                  placeholder="MM-YYYY"
                  value={processMonth}
                  onChange={(e) => setProcessMonth(e.target.value)}
                  style={{ ...inputStyle, maxWidth: 200 }}
                  maxLength={7}
                />
              </div>
              <div className="text-end">
                <button
                  type="submit"
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>

          {/* Informational section */}
          <div style={cardStyle}>
            <h6 className="mb-3" style={{ fontWeight: 600, color: "#334155", fontSize: "15px" }}>
              Possible scenarios for a transaction with lost brokerage:
            </h6>
            <ul className="mb-3 ps-3" style={{ color: "#475569", fontSize: "14px", lineHeight: 1.8 }}>
              {LOST_BROKERAGE_SCENARIOS.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <p className="mb-0" style={{ fontSize: "13px", color: "#94a3b8", lineHeight: 1.6 }}>
              We've handled and excluded these transactions. Please also exclude other scenarios that will not result in any brokerage. Afterward, proceed to investigate the remaining transactions.
            </p>
          </div>

          {/* Decorative icon - leaking bucket concept */}
          <div className="text-center py-4">
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "#f1f5f9",
                color: "#94a3b8",
                fontSize: "36px",
              }}
              aria-hidden
            >
              <i className="fa-solid fa-faucet" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
